import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const base = theme => css`
  background-color: ${theme.color.info['900']};
  color: ${theme.color.monochrome.white};
  display: flex;
  align-items: center;
  min-height: ${rem(56)};
`

const logo = css`
  flex-shrink: 0;
  height: ${rem(40)};
  width: ${rem(48)};
  display: flex;
  align-items: center;
  padding: 0 ${rem(16.5)};

  img {
    width: 100%;
  }
`

const christmasLogo = css`
  padding-left: ${rem(10)};
  padding-right: ${rem(10)};
`

const navMenu = css`
  @media screen and (max-width: 1100px) {
    display: none;
  }
`

const search = theme => css`
  max-width: ${rem(480)};
  margin-left: ${rem(150)};
  flex: 1;

  @media screen and (max-width: ${theme.breakpoints.mediumMonitorBreakpoint}) {
    margin-left: ${rem(40)};
  }

  .search-above-curtain {
    padding: 0;

    .search-backIcon {
      left: ${rem(6)};

      path {
        fill: rgba(${theme.color.monochrome.white_rgba}, 0.5);
      }
    }

    .search-clearIcon {
      opacity: 1;
    }

    input {
      border: none;
      background-color: rgba(${theme.color.monochrome.white_rgba}, 0.25);
      color: ${theme.color.monochrome.white};
      height: ${rem(32)};
      text-indent: ${rem(12)};

      &::placeholder {
        color: rgba(${theme.color.monochrome.white_rgba}, 0.5);
      }

      &:hover {
        & ~ .search-clearIcon {
          svg path {
            fill: ${theme.color.monochrome.white};
            opacity: 0.5;
          }
        }
      }

      &:focus {
        color: ${theme.color.monochrome.black};
        border-color: transparent;

        & ~ svg path {
          fill: ${theme.color.info['900']};
          opacity: 0.5;
        }
      }

      &:not(:placeholder-shown) ~ .search-backIcon {
        display: flex;
      }
    }
  }

  .search-suggestions {
    border: none;
    box-shadow: 0 8px 16px 0px rgba(${theme.color.monochrome.black_rgba}, 0.1);
  }
`

const present = theme => css`
  font-size: ${theme.fontSize.xlarge};
`

export const styles = {
  base,
  logo,
  christmasLogo,
  navMenu,
  search,
  present,
}
